import React, { useEffect } from 'react'
import { useAtom, useSetAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { useWalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { ConvertStep } from 'types/walletActions'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import track from 'utils/tracker'
import { convertFormValuesAtom, convertStepAtom, quoteAtom, quoteEstimateAtom } from './atoms/atoms'
import { ConvertComplete } from './ConvertComplete'
import { ConvertDetails } from './ConvertDetails'
import { ConvertReview } from './ConvertReview'

const convertSteps = [ConvertStep.DETAILS, ConvertStep.REVIEW, ConvertStep.COMPLETE] as const

export const Convert = () => {
  const { t } = useTranslation()
  const [convertStep, setConvertStep] = useAtom(convertStepAtom)
  const setConvertFormValues = useSetAtom(convertFormValuesAtom)
  const setQuoteEstimate = useSetAtom(quoteEstimateAtom)
  const setQuote = useSetAtom(quoteAtom)
  const [walletAction, setWalletAction] = useWalletActionContext()

  const isFormSteps = convertStep === ConvertStep.REVIEW

  const getSheetHeader = (): string => {
    switch (convertStep) {
      case ConvertStep.DETAILS:
        return t('wallets.convert.detailsStepHeader')
      case ConvertStep.REVIEW:
        return t('wallets.convert.reviewStepHeader')
      default:
        return ''
    }
  }

  const handleOnBack = () => {
    track.Amp.track(AmplitudeEvent.EOF_CONVERT_BACK, {
      category: AmplitudeEventCategory.MERCHANT_PORTAL,
      action: AmplitudeEventAction.CLICK,
    })
    const currentStepIndex = convertSteps.indexOf(convertStep)
    if (convertStep === ConvertStep.REVIEW) {
      setQuoteEstimate(null)
      setConvertFormValues(null)
      setQuote(null)
    }
    setConvertStep(convertSteps[currentStepIndex - 1])
  }

  useEffect(() => {
    setWalletAction({
      ...walletAction,
      header: getSheetHeader(),
      ...(isFormSteps ? { onBack: handleOnBack } : { onBack: undefined }),
    })
  }, [convertStep, isFormSteps])

  return (
    <Box width="full">
      {convertStep === ConvertStep.DETAILS && <ConvertDetails />}
      {convertStep === ConvertStep.REVIEW && <ConvertReview />}
      {convertStep === ConvertStep.COMPLETE && <ConvertComplete />}
    </Box>
  )
}
